<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">添加贝商</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="options" slot-scope="text, record">
        <router-link target="_blank" :to="'/seller/info?id=' + record.seller_id">
          <a-button size="small">查看</a-button>
        </router-link>
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定要移除吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="remove(record.id)"
        >
          <a-button type="danger" size="small">移除</a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <CreateModal v-if="show_create" :exh_id="exh_id" @callback="added" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";
export default {
  components: { CreateModal },
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "id",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "电话",
          dataIndex: "tel",
        },
        {
          title: "备注",
          dataIndex: "remarks",
        },
        {
          title: "操作",
          scopedSlots: {
            customRender: "options",
          },
        },
      ],
      exh_id: null,
      list: [],
      show_create: false,
    };
  },
  async created() {
    this.exh_id = this.$route.query.exh_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get("/seller/getExhSeller?exh_id=" + this.exh_id);
      if (r.status == 1) this.list = r.list;
    },
    added(e) {
      this.show_create = false;
      if (e) this.getList();
    },
    async remove(id) {
      const r = await this.$axios.post("/seller/delExhSeller", {
        id: id,
      });

      if (r.status == 1) {
        this.getList();
      }
    },
  },
};
</script>

<style>
</style>